export const fedSubjectsColumns = () => {
    const columns = [
        {
            dataField: 'kod_spr_subj',
            caption: 'ID',
            dataType: 'number',
        },
        {
            dataField: 'kod_subj',
            caption: 'Код субъекта',
            dataType: 'string',
        },
        {
            dataField: 'subject_name',
            caption: 'Субъект Федерации',
            dataType: 'string',
        }
    ];

    return columns;
};

